import { Input } from "antd";

function MaterialComments({
  value,
  disabled,
  onChange
}: {
  value?: string;
  disabled?: boolean;
  onChange: (comments: string) => void;
}) {
  return (
    <div data-testid="material-comments">
      <div className="text-sm text-color-1 mb-2">Add comments</div>
      <Input.TextArea
        value={value}
        disabled={disabled}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        rows={4}
        placeholder=""
        data-testid="material-comments-input"
      />
    </div>
  );
}

export default MaterialComments;
